module.exports = __webpack_public_path__ + "media/splash/launch-1536x2048-11e52e4d.png";